import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import cn from '@/utils/cn';
import LegacyDrillRail from '../LegacyContentRail/LegacyDrillRail';
import { SPANavProvider } from '../SysadminSPA/shared/SPANav';
import { SPAThemeScope } from '../SysadminSPA/shared/SPAThemeScope';
import { UserSearchRoutes as SPAUserSearchRoutes } from '../SysadminSPA/SupportView/UserSearch/UserSearchRoutes';

// AIDEV-NOTE: The SPA's user search mounted on the legacy /admin/user_search page, the way
// admin/AISafetyReport is. Support managers can't reach /sysadmin, so this mount stays; the SPA
// tokens are pinned to their light set (.spa-theme-light in _sysadmin_spa.scss) to match the
// legacy chrome, and SPAThemeScope carries the class to the portalled impersonate dialog.
//
// Two layouts. With the sysadmin rail (withRail: the sysadmin_left_nav flag, see the controller)
// the page drills the rail exactly as in the SPA: the search pane portals into a
// LegacyDrillRail rendered here inside the page's router, the crumb leads back to Support, and
// the detail fills the page. Without it there is no rail column, so the page keeps its own split
// layout with the pane beside the detail.
const THEME_CLASS = 'spa-theme-light';
// The rail is pinned dark beside the light page: the sysadmin's call, so it reads as one strong
// frame around the content.
const RAIL_THEME_CLASS = 'spa-theme-dark';

const groundClasses = cn(
  THEME_CLASS,
  'tw-box-border tw-bg-spa-bg tw-text-spa-on-bg',
  'tw-shadow-[0_0_0_100vmax_var(--spa-bg)]',
);

export const UserSearchRoutes = () => <SPAUserSearchRoutes layout="split" />;

interface UserSearchProps {
  signOutPath?: string;
  supportPath?: string;
  userName?: string;
  withRail?: boolean;
}

const UserSearch = ({
  signOutPath = '', supportPath = '', userName = '', withRail = false,
}: UserSearchProps) => (
  <ReactQueryProvider>
    <BrowserRouter basename="/admin/user_search">
      {withRail ? (
        <SPANavProvider>
          <div className={RAIL_THEME_CLASS} id="sysadmin_content_rail">
            <SPAThemeScope className={RAIL_THEME_CLASS}>
              <div className="tw-h-full">
                <LegacyDrillRail backHref={supportPath} signOutPath={signOutPath} userName={userName} />
              </div>
            </SPAThemeScope>
          </div>
          <SPAThemeScope className={THEME_CLASS}>
            <div className={groundClasses} style={{ clipPath: 'inset(0 -100vmax)' }}>
              <SPAUserSearchRoutes layout="rail" />
            </div>
          </SPAThemeScope>
        </SPANavProvider>
      ) : (
        <SPAThemeScope className={THEME_CLASS}>
          <div className={THEME_CLASS}>
            <UserSearchRoutes />
          </div>
        </SPAThemeScope>
      )}
    </BrowserRouter>
  </ReactQueryProvider>
);

export default UserSearch;
